import { render, staticRenderFns } from "./BadgeYearParts.vue?vue&type=template&id=2c41af02&scoped=true"
import script from "./BadgeYearParts.vue?vue&type=script&lang=ts"
export * from "./BadgeYearParts.vue?vue&type=script&lang=ts"
import style0 from "./BadgeYearParts.vue?vue&type=style&index=0&id=2c41af02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c41af02",
  null
  
)

export default component.exports